module.exports = __webpack_public_path__ + "img/EIXO04.532ba151.png";